/**
 * Australian trade benchmarks (2025–26 style ranges) for pricing calculator comparisons.
 * Sources: industry survey ranges — display labels only; not financial advice.
 */

export const OTHER_AVG_SMALL_JOB_AUD = 250;

export const AU_TRADE_BENCHMARKS = [
  {
    id: 'plumber',
    label: 'Plumber',
    hourlyRate: '$100–$175',
    smallJob: '$250–$500 (tap, drain)',
    midJob: '$800–$2,000 (hot water, bathroom)',
    largeJob: '$3,000–$10,000+ (renovation, commercial)',
    leadCost: '$40–$120',
    avgSmallJobMidAUD: 375,
  },
  {
    id: 'electrician',
    label: 'Electrician',
    hourlyRate: '$70–$140',
    smallJob: '$200–$500 (powerpoint, light)',
    midJob: '$800–$2,500 (switchboard, rewire)',
    largeJob: '$3,000–$15,000+ (solar, full fit-out)',
    leadCost: '$40–$120',
    avgSmallJobMidAUD: 350,
  },
  {
    id: 'hvac',
    label: 'HVAC / Air Con',
    hourlyRate: '$100–$175',
    smallJob: '$150–$400 (service/repair)',
    midJob: '$2,000–$5,000 (split system install)',
    largeJob: '$8,000–$25,000+ (ducted system)',
    leadCost: '$50–$130',
    avgSmallJobMidAUD: 275,
  },
  {
    id: 'carpenter',
    label: 'Carpenter',
    hourlyRate: '$80–$130',
    smallJob: '$300–$800 (decking repair, shelving)',
    midJob: '$2,000–$8,000 (deck, fit-out)',
    largeJob: '$15,000–$50,000+ (extension, reno)',
    leadCost: '$40–$100',
    avgSmallJobMidAUD: 550,
  },
  {
    id: 'painter',
    label: 'Painter',
    hourlyRate: '$45–$90',
    smallJob: '$400–$900 (room interior)',
    midJob: '$2,000–$6,000 (full interior)',
    largeJob: '$6,000–$20,000+ (exterior, large home)',
    leadCost: '$30–$90',
    avgSmallJobMidAUD: 650,
  },
  {
    id: 'tiler',
    label: 'Tiler',
    hourlyRate: '$50–$100',
    smallJob: '$300–$700 (splashback, small area)',
    midJob: '$1,500–$4,000 (bathroom)',
    largeJob: '$4,000–$15,000+ (whole home/commercial)',
    leadCost: '$30–$80',
    avgSmallJobMidAUD: 500,
  },
  {
    id: 'landscaper',
    label: 'Landscaper',
    hourlyRate: '$60–$120',
    smallJob: '$200–$600 (lawn mow, maintenance)',
    midJob: '$2,000–$8,000 (garden makeover)',
    largeJob: '$10,000–$50,000+ (full landscaping)',
    leadCost: '$30–$80',
    avgSmallJobMidAUD: 400,
  },
  {
    id: 'roofer',
    label: 'Roofer',
    hourlyRate: '$80–$150',
    smallJob: '$300–$800 (repair, replace tiles)',
    midJob: '$3,000–$8,000 (partial re-roof)',
    largeJob: '$10,000–$30,000+ (full re-roof)',
    leadCost: '$50–$130',
    avgSmallJobMidAUD: 550,
  },
  {
    id: 'builder',
    label: 'Builder / Concreter',
    hourlyRate: '$80–$150',
    smallJob: '$500–$1,500 (concrete slab, path)',
    midJob: '$5,000–$20,000 (driveway, patio)',
    largeJob: '$50,000–$500,000+ (new build, reno)',
    leadCost: '$150–$400',
    avgSmallJobMidAUD: 1000,
  },
  {
    id: 'handyman',
    label: 'Handyman',
    hourlyRate: '$40–$90',
    smallJob: '$100–$300 (minor repairs)',
    midJob: '$500–$1,500 (multi-task job)',
    largeJob: '$1,500–$4,000 (larger odd jobs)',
    leadCost: '$20–$60',
    avgSmallJobMidAUD: 200,
  },
  {
    id: 'other',
    label: 'Other',
    hourlyRate: 'Varies',
    smallJob: `~$${OTHER_AVG_SMALL_JOB_AUD} average job (estimate)`,
    midJob: '—',
    largeJob: '—',
    leadCost: 'Varies',
    avgSmallJobMidAUD: OTHER_AVG_SMALL_JOB_AUD,
    isOther: true,
  },
];

export function getBenchmarkById(id) {
  return AU_TRADE_BENCHMARKS.find((b) => b.id === id) || AU_TRADE_BENCHMARKS.find((b) => b.id === 'other');
}
